export enum ResourceTypeEnum {
  TRAINING,
  EXAM,
}
